class CartDrawer extends HTMLElement {
    constructor() {
      super()
  
      this.addEventListener('keyup', (evt) => {
        evt.code === 'Escape' && this.close()
      })
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      )
      this.setHeaderCartIconAccessibility()
      this.setSavingsMessage()
  
      document.addEventListener('update:cart-line-item', () => {
        this.setSavingsMessage()
      })
    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble')
      cartLink.setAttribute('role', 'button')
      cartLink.setAttribute('aria-haspopup', 'dialog')
      cartLink.addEventListener('click', (event) => {
        event.preventDefault()
        this.open(cartLink)
      })
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault()
          this.open(cartLink)
        }
      })
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy)
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
        this.setSummaryAccessibility(cartDrawerNote)
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {
        this.classList.add('active')
      })
  
      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer')
          const focusElement =
            this.querySelector('.drawer__inner') ||
            this.querySelector('.drawer__close')
          trapFocus(containerToTrapFocusOn, focusElement)
        },
        { once: true }
      )
  
      document.body.classList.add('overflow-hidden')
    }
  
    close() {
      this.classList.remove('active')
      document.body.classList.remove('overflow-hidden')
      // removeTrapFocus(this.activeElement)
    }
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button')
      cartDrawerNote.setAttribute('aria-expanded', 'false')
  
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute(
          'aria-controls',
          cartDrawerNote.nextElementSibling.id
        )
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget.closest('details').hasAttribute('open')
        )
      })
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
    }
  
    async renderContents(parsedState) {
      if (!parsedState.sections) {
        parsedState.sections = await this.parsedStateFallback()
      }
      this.querySelector('.drawer__inner').classList.contains('is-empty') &&
        this.querySelector('.drawer__inner').classList.remove('is-empty')
      this.productId = parsedState.id
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id)
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        )
      })
  
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener(
          'click',
          this.close.bind(this)
        )
        this.open()
        emit('update:cart-line-item')
      })
    }
  
    async parsedStateFallback() {
      const sections = await fetch(
        `${routes.cart_url}?sections=${this.getSectionsToRender().map(
          (section) => section.id
        )}`
      )
      return await sections.json()
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ]
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)
    }
  
    setActiveElement(element) {
      this.activeElement = element
    }
  
    setSavingsMessage() {
      const savings = this.querySelectorAll('[data-line-item-saving]')
      const target = this.querySelector('#CartSavings')
      const moneyFormat = window.cartStrings.money_format
  
      if (target && savings.length > 0) {
        const targetChild = target.querySelector('span')
        let totalSavings = 0
  
        savings.forEach((saving) => {
          totalSavings +=
            (parseInt(saving.dataset.lineItemSaving) *
              parseInt(saving.dataset.lineItemQuantity)) /
            100
        })
  
        target.classList.remove('hidden')
        targetChild.innerHTML = moneyFormat.replace(
          '{{amount}}',
          totalSavings.toLocaleString()
        )
      }
    }
  }
  
  customElements.define('cart-drawer', CartDrawer)
  
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ]
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems)
  